module.exports = __webpack_public_path__ + "img/arrow-down.38dab9bc.svg";